import React from 'react'
import ScrollUpButton from 'react-scroll-up-button'

const ShopPage = () => (
  <div className='shop'>
    <h2>駄菓子屋への思い</h2>
    <ul className="breadcrumb">
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <a href="/" itemProp="url">
          <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
        </a>
      </li>
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <span itemProp="title"> <i className="fas fa-caret-right"></i> 駄菓子屋への思い</span>
      </li>
    </ul>
    <div className='column'>
      <img src='images/person-sitting-on-bench-under-tree-1280162.jpg' alt='' />
      <h3>近所にたくさんあった駄菓子屋が無くなってしまった</h3>
      <div className='description'>
        子供の頃、放課後に、小さな手に小銭を握り締めて、毎日のように通った近所の小さな駄菓子屋さん。家の奥にいるおじいさん、おばあさんに「○○さん、くださいな〜」と元気に声をかけた日々。
        <ul>
          <li>チョコ菓子が当たって喜んだり</li>
          <li>ビックリマンを一箱買い占めたり</li>
          <li>10円硬貨を入れるゲームにハマったり</li>
          <li>店先で蛇玉を燃やして怒られたり</li>
          <li>友達と一緒に、ミルクせんべえに梅ジャム塗って食べたり</li>
        </ul>
        人それぞれ、色々な楽しい思い出があるかと思います。大人になった今だから、貴重だったと感じるのではないでしょうか？今の子供達に同じ経験を積ませたい。そんな思いを込めて、小学校・中学校から程近い場所に駄菓子屋を開店しようと決意しました。
      </div>
    </div>
    <div className='column'>
      <img src='images/group-of-people-taking-photo-764681.jpg' alt='' />
      <h3>子供達が遊びに来る日常を想像して下さい</h3>
      <div className='description'>
        自宅に駄菓子屋があって、学校帰りに子供達が笑顔で遊びに来る。私達は入居様と共に、スーパーや大手スーパーにあるような綺麗な駄菓子屋さんではなく、昔ながらの親しみやすい駄菓子屋を作り上げていきます。子供達と共に、
        <ul>
          <li>けん玉・ベーゴマ・銀玉鉄砲で遊んだり</li>
          <li>ファミコンをやったり</li>
          <li>中庭と屋上テラスにある家庭内菜園で作物を育てたり</li>
          <li>小学校から必修になったパソコンを学び合ったり</li>
          <li>子供達に綿菓子をあげる</li>
        </ul>
        このシェアハウスには夢が広がります。核家族化が進み、地域のコミュニティ、人間関係が希薄になった現代には特に必要な存在と考えます。それは子供達だけではなく、入居者自身の生き甲斐に繋がると信じています。
      </div>
    </div>
    <div className='column'>
      <img src='images/japanese-lucky-coin-cat-932261.jpg' alt='' />
      <h3>駄菓子屋はなぜ無くなってしまったのか？</h3>
      <div className='description'>
        儲からず、単純に生活が成り立たないからです。子供のお小遣いからいくら稼いでも、生活するのに十分な金額は得られません。その存在を忘れられしまった現在は更に経営は厳しいのかもしれません。
        <ul>
          <li>コンビニ・スーパーに行けば人気の駄菓子が簡単に手に入る</li>
          <li>今の子供には駄菓子屋に行く習慣がない</li>
          <li>よくわからないお店に入るのは怖い</li>
          <li>お店に入ったら、何か買わないといけないんじゃないか？という先入観</li>
        </ul>
        コンビニのような、店員さんとの程よい距離感、赤の他人関係に慣れてしまった人々にはなかなか受け入れられず、当面は、昔を懐かしんだ大人が買いに来てくれるのを期待する日々になるかもしれません。しかし、希望はあります。商店街のような人間関係が好きな人はとても多いですし、ITと地域のコミュニティの力で解決できると確信しています。社会全体のマインドを変えるのは大変難しいですが、発信力を十分に活かして、地域に密着・集中し、試行錯誤して参ります。
      </div>
    </div>
    <ScrollUpButton style={{width: 30, height: 30}} />
  </div>
)

export default ShopPage


// WEBPACK FOOTER //
// ./src/ShopPage.js